import { createAction, props } from '@ngrx/store'

import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { Preference } from '@app/core/model/user-preferences.interface'
import { ScopeVersion } from '@app/core/model/scope-version'
import { TableColumnPreferences } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'
import { ScopeComponent } from '@app/features/scoping/models/component.model'

export enum FolderScopesActionTypes {
  GET_COLUMN_PREFERENCE = '[Folder Details] Get column preference Columns',
  GET_COLUMN_PREFERENCE_SUCCESS = '[Folder Details] Get column preference Columns Success',
  GET_COLUMN_PREFERENCE_FAIL = '[Folder Details] Get column preference Columns Fail',
  UPDATE_COLUMN_PREFERENCE = '[Folder Details] Update Column Preference',
  UPDATE_COLUMN_PREFERENCE_SUCCESS = '[Folder Details] Update Column Preference Success',
  UPDATE_COLUMN_PREFERENCE_FAIL = '[Folder Details] Update Column Preference Fail',

  DELETE_SCOPE = '[Folder Details] Delete Scope',
  DELETE_SCOPE_FAIL = '[Folder Details] Delete Scope Fail',
  DELETE_SCOPE_SUCCESS = '[Folder Details] Delete Scope Success',

  REMOVE_SCOPE = '[Folder Details] Remove Scope',
  REMOVE_SCOPE_FAIL = '[Folder Details] Remove Scope Fail',
  REMOVE_SCOPE_SUCCESS = '[Folder Details] Remove Scope Success',

  UPDATE_SCOPE = '[Folder Details] Update Scope',
  UPDATE_SCOPE_FAIL = '[Folder Details] Update Scope Fail',
  UPDATE_SCOPE_SUCCESS = '[Folder Details] Update Scope Success',

  UPDATE_DELIVERABLE = '[Folder Details] Update Deliverable',
  UPDATE_DELIVERABLE_FAIL = '[Folder Details] Update Deliverable Fail',
  UPDATE_DELIVERABLE_SUCCESS = '[Folder Details] Update Deliverable Success',

  UPDATE_COMPONENT = '[Folder Details] Update Component',
  UPDATE_COMPONENT_FAIL = '[Folder Details] Update Component Fail',
  UPDATE_COMPONENT_SUCCESS = '[Folder Details] Update Component Success',

  GET_SCOPE_DETAILS = '[Folder Details] Get Scope Details',
  GET_SCOPE_DETAILS_FAIL = '[Folder Details] Get Scope Details Fail',
  GET_SCOPE_DETAILS_SUCCESS = '[Folder Details] Get Scope Details Success',

  GET_DELIVERABLE_DETAILS = '[Folder Details] Get Deliverable Details',
  GET_DELIVERABLE_DETAILS_FAIL = '[Folder Details] Get Deliverable Details Fail',
  GET_DELIVERABLE_DETAILS_SUCCESS = '[Folder Details] Get Deliverable Details Success',
}

const getColumnPreference = createAction(FolderScopesActionTypes.GET_COLUMN_PREFERENCE)
const getColumnPreferenceSuccess = createAction(
  FolderScopesActionTypes.GET_COLUMN_PREFERENCE_SUCCESS,
  props<{ columns: TableColumnPreferences }>()
)
const getColumnPreferenceFail = createAction(
  FolderScopesActionTypes.GET_COLUMN_PREFERENCE_FAIL,
  props<{ error: Error }>()
)

const updateColumnPreference = createAction(
  FolderScopesActionTypes.UPDATE_COLUMN_PREFERENCE,
  props<{ preference: Preference }>()
)
const updateColumnPreferenceSuccess = createAction(
  FolderScopesActionTypes.UPDATE_COLUMN_PREFERENCE_SUCCESS,
  props<{ columns: TableColumnPreferences }>()
)
const updateColumnPreferenceFail = createAction(
  FolderScopesActionTypes.UPDATE_COLUMN_PREFERENCE_FAIL,
  props<{ error: Error }>()
)

const deleteScope = createAction(FolderScopesActionTypes.DELETE_SCOPE, props<{ id: number }>())
const deleteScopeFail = createAction(FolderScopesActionTypes.DELETE_SCOPE_FAIL, props<{ error: Error }>())
const deleteScopeSuccess = createAction(FolderScopesActionTypes.DELETE_SCOPE_SUCCESS, props<{ id: number }>())

const removeScope = createAction(FolderScopesActionTypes.REMOVE_SCOPE, props<{ id: number }>())
const removeScopeFail = createAction(FolderScopesActionTypes.REMOVE_SCOPE_FAIL, props<{ error: Error }>())
const removeScopeSuccess = createAction(FolderScopesActionTypes.REMOVE_SCOPE_SUCCESS, props<{ id: number }>())

const updateScope = createAction(FolderScopesActionTypes.UPDATE_SCOPE, props<{ scope: ScopeVersion }>())
const updateScopeFail = createAction(FolderScopesActionTypes.UPDATE_SCOPE_FAIL, props<{ error: Error }>())
const updateScopeSuccess = createAction(FolderScopesActionTypes.UPDATE_SCOPE_SUCCESS, props<{ scope: ScopeVersion }>())

const updateDeliverable = createAction(
  FolderScopesActionTypes.UPDATE_DELIVERABLE,
  props<{ scope: ScopeVersion; deliverable: Deliverable }>()
)
const updateDeliverableFail = createAction(FolderScopesActionTypes.UPDATE_DELIVERABLE_FAIL, props<{ error: Error }>())
const updateDeliverableSuccess = createAction(
  FolderScopesActionTypes.UPDATE_DELIVERABLE_SUCCESS,
  props<{ scope: ScopeVersion; deliverable: Deliverable }>()
)

const updateComponent = createAction(
  FolderScopesActionTypes.UPDATE_COMPONENT,
  props<{ scope: ScopeVersion; component: ScopeComponent }>()
)
const updateComponentFail = createAction(FolderScopesActionTypes.UPDATE_COMPONENT_FAIL, props<{ error: Error }>())
const updateComponentSuccess = createAction(
  FolderScopesActionTypes.UPDATE_COMPONENT_SUCCESS,
  props<{ scope: ScopeVersion; component: ScopeComponent }>()
)

const getScopeDetails = createAction(FolderScopesActionTypes.GET_SCOPE_DETAILS, props<{ scope: ScopeVersion }>())
const getScopeDetailsFail = createAction(
  FolderScopesActionTypes.GET_SCOPE_DETAILS_FAIL,
  props<{ error: Error; id: number }>()
)
const getScopeDetailsSuccess = createAction(
  FolderScopesActionTypes.GET_SCOPE_DETAILS_SUCCESS,
  props<{ scope: ScopeVersion }>()
)

const getDeliverableDetails = createAction(
  FolderScopesActionTypes.GET_DELIVERABLE_DETAILS,
  props<{ scopeId: number; deliverableId: number }>()
)
const getDeliverableDetailsFail = createAction(
  FolderScopesActionTypes.GET_DELIVERABLE_DETAILS_FAIL,
  props<{ error: Error }>()
)
const getDeliverableDetailsSuccess = createAction(
  FolderScopesActionTypes.GET_DELIVERABLE_DETAILS_SUCCESS,
  props<{ scopeId: number; deliverable: Deliverable }>()
)

export const FolderScopesActions = {
  getColumnPreference,
  getColumnPreferenceSuccess,
  getColumnPreferenceFail,
  updateColumnPreference,
  updateColumnPreferenceSuccess,
  updateColumnPreferenceFail,
  deleteScope,
  deleteScopeFail,
  deleteScopeSuccess,
  removeScope,
  removeScopeFail,
  removeScopeSuccess,
  updateScope,
  updateScopeFail,
  updateScopeSuccess,
  updateDeliverable,
  updateDeliverableFail,
  updateDeliverableSuccess,
  updateComponent,
  updateComponentFail,
  updateComponentSuccess,
  getScopeDetails,
  getScopeDetailsFail,
  getScopeDetailsSuccess,
  getDeliverableDetails,
  getDeliverableDetailsFail,
  getDeliverableDetailsSuccess,
}
